import React from 'react'
import { CircularProgress, Tooltip } from '@mui/material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import RefreshIcon from '@mui/icons-material/Refresh'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

export default function PriceRowAction({ action, row, refreshing, disabled, onClick, ...props }) {
    const isDelete = action === 'delete'
    return (
        <GridActionsCellItem
            {...props}
            label={`${isDelete ? 'Delete' : 'Refresh'} ${row.kmat}`}
            {...(isDelete ? { color: 'error' } : {})}
            icon={
                <Tooltip title={isDelete ? 'Delete cached price' : refreshing ? 'Refreshing...' : 'Refresh price'}>
                    {isDelete ? <DeleteOutlineIcon fontSize='small' /> : refreshing ? <CircularProgress size={16} /> : <RefreshIcon fontSize='small' />}
                </Tooltip>
            }
            disabled={disabled}
            onClick={(event) => {
                event.stopPropagation()
                onClick(row)
            }}
        />
    )
}
